import clsx from 'clsx';
import styles from './StatusNew.module.scss';

const StatusNew = ({ status, count }: { status: string; count?: number }) => {
  return (
    <div className={styles.StatusNew}>
      <span
        className={clsx(styles.status, {
          [styles.active]: status === 'active' || status === 'replacement',
          [styles.discontinued]: status === 'discontinued',
        })}
      >
        {status === 'active' || status === 'replacement'
          ? 'Активен'
          : 'Недоступно к заказу'}
      </span>
      {(status === 'active' || status === 'replacement') && (
        <span className={styles.available}>
          {count && count > 0 ? (
            <>
              Доступна на складе в РФ
              <img src="/icons/ru.png" alt="" />
            </>
          ) : (
            <>
              Доступна к заказу во Франции
              <img src="/icons/fr.png" alt="" />
            </>
          )}
        </span>
      )}
    </div>
  );
};

export default StatusNew;
